import config from "../config";

export const GLOBALS = {
  local_state_name: config.local_state_name,
  state_localization: "localization",
};

// Auth
export const AUTH = {
  AUTH_REQUEST: "AUTH_REQUEST",
  AUTH_RESPONSE: "AUTH_RESPONSE",
  AUTH_LOADED: "AUTH_LOADED",
  AUTH_ERROR: "AUTH_ERROR",
  AUTH_LOGOUT: "AUTH_LOGOUT",
  AUTH_SET_USER: "AUTH_SET_USER",
  AUTH_FAILURE: "AUTH_FAILURE",
  AUTH_IS_AUTH: "AUTH_IS_AUTH",
  AUTH_DEMO: "AUTH_DEMO",
  AUTH_CHANGE_POPUP: "AUTH_CHANGE_POPUP",
};

// Locales
export const LOCALE = {
  CHANGE_LOCALE: "CHANGE_LOCALE",
  LOADING_LOCALE: "LOADING_LOCALE",
  END_LOADING_LOCALE: "END_LOADING_LOCALE",
};

//theme
export const THEME = {
  CHANGE_THEME: "CHANGE_THEME",
};

//user
export const USER = {
  USER_REQUEST: "USER_REQUEST",
  USER_RESPONSE: "USER_RESPONSE",
  USER_LOADED: "USER_LOADED",
  USER_FIELD: "USER_FIELD",
};

//alert
export const ALERT = {
  ALERT_SUCCESS: "ALERT_SUCCESS",
  ALERT_ERROR: "ALERT_ERROR",
  ALERT_HIDE: "ALERT_HIDE",
};

//trading
export const TRADING = {
  CHANGE_PAIR: "CHANGE_PAIR",
  UPDATE_USER_PAIR_LIST: "UPDATE_USER_PAIR_LIST",
  DELETE_FROM_USER_PAIR_LIST: "DELETE_FROM_USER_PAIR_LIST",
  ADD_USER_PAIR_LIST: "ADD_USER_PAIR_LIST",
};

//bids

export const BIDS = {
  UPDATE_FIELD: "UPDATE_FIELD",
  SHOW_NOTIFICATION: "SHOW_NOTIFICATION",
  HIDE_NOTIFICATION: "HIDE_NOTIFICATION",
  ADD_TO_OPENED_HISTORY: "ADD_TO_OPENED_HISTORY",
  REMOVE_FROM_OPENED_HISTORY: "REMOVE_FROM_OPENED_HISTORY",
  ADD_TO_CLOSED_HISTORY: "ADD_TO_CLOSED_HISTORY",
  CHANGE_CLOSED_HISTORY: "CHANGE_CLOSED_HISTORY",
  CHANGE_OPENED_HISTORY: "CHANGE_OPENED_HISTORY",
  HISTORY_REQUEST: "HISTORY_REQUEST",
  HISTORY_LOADED: "HISTORY_LOADED",
  CHANGE_HISTORY_TYPE: "CHANGE_HISTORY_TYPE",
  TOGGLE_HISTORY: "TOGGLE_HISTORY",
  LOADING_CLOSED_HISTORY: "LOADING_CLOSED_HISTORY",
  REMOVE_CLOSED_HISTORY: "REMOVE_CLOSED_HISTORY",
};

export const WALLET = {
  GET_WALLETS: "GET_WALLETS",
  CHANGE_WALLET: "CHANGE_WALLET",
  UPDATE_WALLETS: "UPDATE_WALLETS",
  WALLET_LOADING: "WALLET_LOADING",

  SHOW_WITHDRAWAL: "SHOW_WITHDRAWAL",
  HIDE_WITHDRAWAL: "HIDE_WITHDRAWAL",

  SHOW_POPUP: "SHOW_SUCCESS",
  HIDE_POPUP: "HIDE_POPUP",

  SHOW_TRANSFER_POPUP: "SHOW_TRANSFER_POPUP",
  HIDE_TRANSFER_POPUP: "HIDE_TRANSFER_POPUP",
};

export const CHANEL = {
  CHANGE_USER_CHANEL: "CHANGE_USER_CHANEL",
};

//futures
export const FUTURES = {
  CHANGE_PAIR: "FUTURES_CHANGE_PAIR",
  SYNC_PAIR: "FUTURES_SYNC_PAIR",
  UPDATE_PRICE: "FUTURES_UPDATE_PRICE",
  UPDATE_CHART_PRICE: "FUTURES_UPDATE_CHART_PRICE",
  FUTURE_TICKERS_LOADING: "FUTURE_TICKERS_LOADING",
  FUTURE_ORDER_BOOK_LOADING: "FUTURE_ORDER_BOOK_LOADING",
  CHANGE_TICKER_DATA: "FUTURES_CHANGE_TICKER_DATA",
  UPDATE_ALL_TICKERS_CACHE: "FUTURES_UPDATE_ALL_TICKERS_CACHE",
  CHANGE_MARK_PRICE: "FUTURES_CHANGE_MARK_PRICE",
  SET_MARK_TICK_AT: "FUTURES_SET_MARK_TICK_AT",
  POSITION_OPENED: "FUTURES_POSITION_OPENED",
  SET_OPEN_POSITIONS: "FUTURES_SET_OPEN_POSITIONS",
  SET_POSITION_MARK_PRICES: "FUTURES_SET_POSITION_MARK_PRICES",
  UPDATE_ORDER_BOOK: "FUTURES_UPDATE_ORDER_BOOK",
  SHOW_NOTIFICATION: "FUTURES_SHOW_NOTIFICATION",
  HIDE_NOTIFICATION: "FUTURES_HIDE_NOTIFICATION",
  REQUEST_POSITION_CLOSE: "FUTURES_REQUEST_POSITION_CLOSE",
  CLEAR_POSITION_CLOSE_REQUEST: "FUTURES_CLEAR_POSITION_CLOSE_REQUEST",
  SET_POSITION_LEVELS_VISIBLE: "FUTURES_SET_POSITION_LEVELS_VISIBLE",
};

//verification
export const VERIFICATION = {
  INIT_VERIFICATION: "VERIFICATION_INIT_VERIFICATION",
  SET_DATA: "VERIFICATION_SET_DATA",
  SET_DOCUMENT_FILE: "VERIFICATION_SET_DOCUMENT_FILE",
  SET_DOCUMENT_TYPE: "VERIFICATION_SET_DOCUMENT_TYPE",
  RESET: "VERIFICATION_RESET",
};

export * from "./routes";
export * from "./wallet-type";
export * from "./regions";
export * from "./navigation";
